export function setMetaTag(property, content) {
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/** Resolves to `path` if that image actually exists, else `fallback`. */
export function resolveImageWithFallback(path, fallback, onResolve) {
  const img = new Image();
  img.onload = () => onResolve(path);
  img.onerror = () => onResolve(fallback);
  img.src = path;
}

